import React from "react";
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

// Imagini
import v1 from "assets/images/poze-site/14-1-curatenie-vile-apart.webp";
import v2 from "assets/images/poze-site/14-2-curatenie-vile-apart.webp";
import v3 from "assets/images/poze-site/14-3-curatenie-vile-apart.webp";
import v4 from "assets/images/poze-site/14-4-curatenie-vile-apart.webp";
import v5 from "assets/images/poze-site/14-5-curatenie-vile-apart.webp";
import v6 from "assets/images/poze-site/14-6-curatenie-vile-apart.webp";

const images = [v1, v2, v3, v4, v5, v6];

function ServicesSection() {
    return (
        <MKBox py={6}>
            <Container>
                <MKTypography variant="h2" textAlign="center" mb={4}>
                    Galerie foto – Servicii de curățenie vile
                </MKTypography>

                <Grid container spacing={3} justifyContent="center">
                    {images.map((img, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <MKBox
                                component="div"
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    paddingTop: "70%", // raport fix
                                    overflow: "hidden",
                                    borderRadius: "lg",
                                    boxShadow: 3,
                                }}
                            >
                                <MKBox
                                    component="img"
                                    src={img}
                                    alt={`Curățenie vile ${index + 1}`}
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            </MKBox>
                        </Grid>
                    ))}
                </Grid>

                <MKButton
                    variant="gradient"
                    color="info"
                    size="large"
                    component="a"
                    href="/contact-curatenie"
                    sx={{ mt: 6, mx: "auto", display: "block" }}
                >
                    Solicită o vizită GRATUITĂ pentru ofertă!
                </MKButton>
            </Container>
        </MKBox>
    );
}

export default ServicesSection;
